module.exports = __webpack_public_path__ + "img/2184701.jpg";